import * as React from 'react';

import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility';
import {
  DropdownInput,
  EXTRA_SMALL_ICON_BASE_SRC,
} from '../../../../Shared/index';

const stateStandardsFrameworkAbbreviationToActivitiesLink = {
  'TX': '/assign/quill-for-texas'
}

const ReportStandardsModal = ({ closeModal, selectedStateStandardsFramework, handleChangeSelectedStateStandardsFramework, allStateStandardsFrameworks, }) => {
  const { modalRef } = useModalAccessibility(closeModal);
  
  const [newSelectedStateStandardsFramework, setNewSelectedStateStandardsFramework] = React.useState(selectedStateStandardsFramework)

  function handleClickSaveStateStandardsFramework(): void {
    handleChangeSelectedStateStandardsFramework(newSelectedStateStandardsFramework)
    closeModal('Report standards saved')
  }

  const stateStandardFrameworkOptions = allStateStandardsFrameworks.map(framework => ({ ...framework, value: framework.id, label: `${framework.name} (${framework.abbreviation})` }))

  return (
    <div className="modal-container report-standards-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="reportStandardsModal"
        aria-modal="true"
        className="report-standards-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="title">
          <h2 id="reportStandardsModal">Report Standards</h2>
        </div>
        <p>Select which standards this report should align to:</p>
        <DropdownInput
          ariaLabel="Report Standards"
          className="medium bordered"
          handleChange={setNewSelectedStateStandardsFramework}
          isSearchable={true}
          options={stateStandardFrameworkOptions}
          value={stateStandardFrameworkOptions.find(framework => framework.id === newSelectedStateStandardsFramework?.id)}
        />
        {stateStandardsFrameworkAbbreviationToActivitiesLink[newSelectedStateStandardsFramework?.abbreviation] && (
          <section className="activities-section">
            <h3>{newSelectedStateStandardsFramework.abbreviation} Activities</h3>
            <p>Explore activities related to {newSelectedStateStandardsFramework.abbreviation} standards</p>
            <a className="quill-button medium green outlined focus-on-light" href={stateStandardsFrameworkAbbreviationToActivitiesLink[newSelectedStateStandardsFramework.abbreviation]} rel="noopener noreferrer" target="_blank">
              Browse activities
              <img alt="" src={`${EXTRA_SMALL_ICON_BASE_SRC}/arrow-up-right.svg`} />
            </a>
          </section>
        )}
        <div className="request-link-and-buttons">
          <a href='https://quillorg.canny.io/feedback/p/add-additional-standards' rel="noopener noreferrer" target="_blank">Don’t see yours listed? Request it here</a>
          <div className="form-buttons">
            <button className="quill-button outlined medium grey focus-on-light" onClick={closeModal} type="button">Cancel</button>
            <button className='quill-button contained medium green focus-on-light' disabled={newSelectedStateStandardsFramework === selectedStateStandardsFramework} onClick={handleClickSaveStateStandardsFramework} type="button">Save</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReportStandardsModal
